import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import RouterContext, {RouterData} from 'contexts/RouterContext';

export interface WithRouterProps {
    router: RouterData;
}

export default function withRouter<T extends WithRouterProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithRouter extends React.Component<Omit<T, keyof WithRouterProps>> {
        static displayName = `withRouter(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = RouterContext;

        render() {
            return <WrappedComponent {...(this.props as T)} router={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithRouter, WrappedComponent);
    return WithRouter;
}
